$(function () {

    'use strict';

    const timePeriods = RivalIQ.state.timePeriods;
    RivalIQ.apps.Shell.execute('show:app', {
        options: {
            editCompanyId: window.editCompanyId,
            adminEditingProperties: window.adminEditingProperties
        },
        page: RivalIQ.configuration.menus.getConfiguration().ADMIN,
        components: {
            companySets: {
                disabled: true
            },
            timePeriod: timePeriods.getDefinitionByType(timePeriods.types.NOT_AVAILABLE)
        },
        app: RivalIQ.apps.Admin
    });
});
